import ScrollReveal from "../../../components/feature/ScrollReveal";
import { missionData } from "../../../mocks/companyData";

export default function MissionSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-navy text-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal direction="up">
            <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
              {missionData.label}
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold leading-tight">
              {missionData.title}
            </h2>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <p className="mt-8 text-xl md:text-2xl font-serif font-semibold text-airdoa-gold leading-[1.6]">
              {missionData.lead}
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={250}>
            <div className="mt-8 flex flex-col gap-5">
              {missionData.paragraphs.map((paragraph, idx) => (
                <p
                  key={idx}
                  className="text-sm md:text-base text-white/70 leading-[1.9]"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}